var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings", {
    staticClass: "column-content-settings text-settings",
    attrs: {
      title: _vm.resource("TemplateColumnTextSettings_Settings_Title"),
      region: "right"
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _vm.canCalculateHorizontalMargin
              ? _c("settings-slider", {
                  attrs: {
                    label: _vm.resource(
                      "TemplateManager_Shared_HorizontalMargin_Label"
                    ),
                    "value-suffix": "px",
                    min: 0,
                    max: _vm.maxHorizontalMargin
                  },
                  model: {
                    value: _vm.model.style.horizontalMargin,
                    callback: function($$v) {
                      _vm.$set(_vm.model.style, "horizontalMargin", $$v)
                    },
                    expression: "model.style.horizontalMargin"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource(
                  "TemplateManager_Shared_VerticalMargin_Label"
                ),
                "value-suffix": "px",
                min: 0,
                max: 250
              },
              model: {
                value: _vm.model.style.verticalMargin,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "verticalMargin", $$v)
                },
                expression: "model.style.verticalMargin"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }